import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import "./Read.css";
import { Link, useParams } from "react-router-dom";
import Nvabar from "./Nvabar";

const Read = () => {
  let params = useParams();
  const [results, setResults] = useState({});
  const token = Cookies.get("token");

  useEffect(() => {
    console.log(params.type);
    request(params.id);
  }, [params.type]);

  //api call
  const request = async (id) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        ` ${process.env.REACT_APP_URL}particular${id}`,
        config
      );

      await setResults(data[0]);
      console.log(results);
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div className="div">
      <Nvabar />
      <div className="container">
        <img className="image" src={results.image} alt="Blog Post" />
        <div className="content2">
          <h1>{results.Title}</h1>
          <p>{results.Content}</p>
          <span>
            You can share also your Knowledge,Experience and let the World
            discover it..
          </span>
        </div>
      </div>
    </div>
  );
};

export default Read;
